module.exports = __webpack_public_path__ + "static/img/logo-innovare.12be5e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-innovare.png
// module id = zdm5
// module chunks = 3